import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

if($('.staff-detail').length) {
  var controller = new ScrollMagic.Controller();

  var scene_staff1 = new ScrollMagic.Scene({
    triggerElement: ".js-detail-01",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -50
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff1.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".js-detail-01 dt", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".js-detail-01 dd", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });

  var scene_staff2 = new ScrollMagic.Scene({
    triggerElement: ".js-detail-02",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -50
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff2.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".js-detail-02 dt", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".js-detail-02 dd", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });

  var scene_staff3 = new ScrollMagic.Scene({
    triggerElement: ".js-detail-03",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -50
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff3.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".js-detail-03 dt", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".js-detail-03 dd", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });

  var scene_staff4 = new ScrollMagic.Scene({
    triggerElement: ".staff-page-others",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -50
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff4.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".staff-page-others__title h2", 1,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".staff-page-others__title .staff-page-others__sub-title", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });

  var scene_staff5 = new ScrollMagic.Scene({
    triggerElement: ".staff-page-others__unit.if-store",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -80
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff5.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".staff-page-others__unit.if-store h3", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });

  var scene_staff6 = new ScrollMagic.Scene({
    triggerElement: ".staff-page-others__unit.if-office",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -80
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_staff6.on('enter', ()=>{
    var tl = new TimelineMax();


    tl.to(".staff-page-others__unit.if-office h3", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_job1.scrollOffset());
    // console.log(scene_job1.state());
    // console.log(scene_job1.triggerPosition());


  });
}
